import { SelectionApp } from '../../../types/app';

import { createStore, IGlobalState } from '../../../store';
import { setSettings } from '../../../store/reducers/siteSettings';
import { addDictionary } from '../../../store/reducers/dictionaries';
import { setLocations } from '../../../store/reducers/locations';
import { setMetadata } from '../../../store/reducers/metadata';
import { DEFAULT_METADATA } from '../../../services/gateway/gateway.constants';
import { UTM_COOKIE_MAP, UTM_MARKS } from '../../../constants';
import { PURPOSE_SOURCE } from '../../../constants/sources';
import { DEFAULT_SELECTION_EXPERIMENTS_VARIANTS, setAbData } from '../../../store/reducers/abData';
import { setUserInvitedBy } from '../../../store/reducers/userInvitedBy';
import { setUtmMarks } from '../../../store/reducers/utmMarks';
import { readUtmCookie } from './utils/readUtmCookie';

const getUtmMarksFromCookie = (ctx: SelectionApp.PageContext) => {
    const cookieValue = readUtmCookie(ctx);

    const parsed = (cookieValue.split('|') || []).reduce((output, item) => {
        const [name, value] = item.split('=');
        if (value) {
            output[name] = value;
        }
        return output;
    }, {} as Record<string, string>);

    return Object.values(UTM_MARKS).reduce((prev, name) => {
        const value = parsed[UTM_COOKIE_MAP[name]];
        if (value) {
            prev[name] = value;
        } else {
            prev[name] = UTM_MARKS.MEDIUM === name ? '(none)' : '(not set)';
        }
        return prev;
    }, {} as Record<string, string>);
};

const getUtmMarksFromQuery = (ctx: SelectionApp.PageContext) => {
    const { query = {} } = ctx;

    return Object.values(UTM_MARKS).reduce((prev, name) => {
        const value = query[name] ? String(query[name]) : undefined;
        if (value) {
            prev[name] = value;
        } else {
            prev[name] = UTM_MARKS.MEDIUM === name ? '(none)' : '(not set)';
        }
        return prev;
    }, {} as Record<string, string>);
};

/**
 * Для загрузки Next-параметров на стороне client
 * ТОЛЬКО КЛИЕНТСКИЙ КОД, БЕЗ SSR
 */
export const getInitialState = (ctx: SelectionApp.PageContext): IGlobalState => {
    const store = createStore();
    store.dispatch(setSettings(ctx.req.__SITE_SETTINGS__ || {}));
    store.dispatch(addDictionary({ name: 'carBrands', options: ctx.req.__CAR_BRANDS__ || [] }));
    store.dispatch(setLocations({ centers: ctx.req.__REGIONAL_CENTERS__ || [], regions: ctx.req.__REGIONS__ || [] }));
    const showingSeoBlocks = (ctx.req.__CONF__ || {}).showingSeoBlocks || {};
    store.dispatch(
        setMetadata({
            metadata: ctx.req.__METADATA__ || DEFAULT_METADATA,
            showingSeoBlocks: {
                seoBlocks: showingSeoBlocks?.seoBlocks || false,
                prefooter: showingSeoBlocks?.prefooter || false,
                breadcrumbs: showingSeoBlocks?.breadcrumbs || false,
                reviews: showingSeoBlocks?.reviews || false,
            },
            seoBlocksHidden: false,
        }),
    );

    store.dispatch(
        setUtmMarks({
            cookie: getUtmMarksFromCookie(ctx),
            query: getUtmMarksFromQuery(ctx),
        }),
    );

    store.dispatch(
        addDictionary({
            name: 'purposes',
            /** Баннер ЦИАН удален в рамках CF-1913 */
            options: PURPOSE_SOURCE,
        }),
    );
    const abTestingInfo = ctx.req.__AB_TESTING__;
    store.dispatch(
        setAbData({
            experiments: abTestingInfo?.experiments || DEFAULT_SELECTION_EXPERIMENTS_VARIANTS,
            userId: abTestingInfo?.userData?.id || null,
            isDefaultVariants: !abTestingInfo?.experiments,
        }),
    );
    const friend = ctx.req.__FRIEND__;
    if (friend && friend.firstName) {
        const name = friend.firstName.split(' ')[0] || 'Пользователь';
        store.dispatch(setUserInvitedBy({ firstName: name[0].toUpperCase() + name.slice(1) }));
    }

    return store.getState();
};
